import {
  FETCH_ASSIGNED_PLANS_LOADING,
  FETCH_ASSIGNED_PLANS_SUCCESS,
  FETCH_ASSIGNED_PLANS_FAILED,
} from "../types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const assignedPlansReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_ASSIGNED_PLANS_LOADING:
      return { ...state, loading: true, error: null };
    case FETCH_ASSIGNED_PLANS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_ASSIGNED_PLANS_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
